import{jsxs as e,jsx as n}from"react/jsx-runtime";import{useState as t,useRef as i,useEffect as o,useMemo as r}from"react";import l,{css as s}from"styled-components";import{useTranslation as c}from"react-i18next";import{NavigationArrowIcon as a}from"../../icons/NavigationArrowIcon.js";import{WarningSmallIcon as p}from"../../icons/WarningSmallIcon.js";import{withTranslations as d}from"../../services/translations/withTranslations.js";import{CHANNELS as f,DEFAULT_ENABLED_CHANNELS as m}from"./constants/channelSwitcherConstants.js";import{getAvailableChannels as h}from"./utils/getAvailableChannels.js";import{Tooltip as x}from"../../components/Tooltip/Tooltip.js";import{HelveticaFontStyle as g}from"../../style/fonts/helveticaFontStyle.js";import{useRestrictions as u}from"../../services/restrictions/context/restrictionsContext.js";const b=l.div`
  display: flex;
  position: relative;
  align-items: center;
  width: 100%;
  padding: 17px 30px 17px 20px;
  box-sizing: border-box;
`,v=l.button`
  ${g}
  min-height: 40px;
  width: 100%;
  border: none;
  outline: none;
  background-color: transparent;
  color: #333f48;
  font-size: 20px;
  font-weight: bold;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0;
`,y=l.div`
  position: relative;
  width: 70px;

  & > * {
    position: absolute;
    left: 0;
    top: 50%;
    transform: translateY(-50%);
  }
`,w=l.img`
  width: 37px;
  height: 37px;
`,j=l.div`
  position: absolute;
  background-color: white;
  box-sizing: border-box;
  z-index: 3;
  top: 100%;
  left: 0;
  width: 100%;
  padding: 4px 0;
  box-shadow: 0px 13px 15px rgba(0, 0, 0, 0.05);
`,k=l.div`
  ${g}
  display: flex;
  align-items: center;
  padding: 15px 8px;
  box-sizing: border-box;
  background-color: transparent;
  font-size: 14px;
  cursor: pointer;
  font-weight: bold;

  &:hover {
    background: #f5f5f5;
  }
`,C=l.span`
  margin: 0 8px;
  ${({open:e})=>e&&s`
      svg {
        transform: rotate(180deg);
      }
    `}
`,$=l.div`
  margin-left: 18px;
`,z=l.div`
  display: flex;
  align-items: center;
`,S=l.span`
  position: relative;

  ${({$errorsCount:e})=>e&&e>0&&s`
      &:before {
        content: '${e}';
        background: #e31c3d;
        position: absolute;
        top: -6px;
        right: ${1===String(e).length?"-14px":"-20px"};
        border-radius: 50%;
        font-size: 11px;
        color: #fff;
        padding: ${1===String(e).length?"0 4px":"2px 4px"};
        display: flex;
        justify-content: center;
        align-items: center;
        font-family: monospace;
      }
    `};
`,T=l.div`
  margin-right: 18px;
  display: flex;
  alignitems: center;

  & img,
  & svg {
    width: 20px;
    height: 20px;
  }
`,E=d((({onChannelSwitched:l,channel:s,enabledChannels:d=m})=>{const{t:g}=c(),{channelsErrors:E,errorsCount:A}=u(),[I,L]=t(),[V,D]=t(!1),F=f.find((({value:e})=>e===I)),N=F?.icon,O=i(null);o((()=>{const e=f.find((({value:e})=>e===s));if(e&&!d.includes(e?.id)){const e=f.find((({id:e})=>e===d[0]));L(e?.value)}else L(s)}),[s,d]),o((()=>{const e=e=>{O.current&&(e.preventDefault(),D(!1))};return V&&setTimeout((()=>{document.addEventListener("click",e)}),1),()=>{document.removeEventListener("click",e)}}),[V]);const W=r((()=>h(f).filter((({id:e})=>d.includes(e))).map((e=>({...e,isValid:!E||!Object.keys(E).find((n=>n===e.id))})))),[E,d]);return e(b,{children:["string"==typeof F?.icon&&n(y,{children:n(w,{alt:`${F?.value} selected icon`,src:F?.icon})}),"function"==typeof N&&n(y,{children:n(N,{})}),e(v,{onClick:()=>D(!V),children:[n(S,{$errorsCount:A,children:F?.label}),d.length>=2&&n(C,{open:V,children:n(a,{})})]}),d.length>=2&&V&&e(j,{ref:O,children:[(!I||I<1)&&n(k,{children:g("common.channel")}),W.map((({label:t,value:i,icon:o,isValid:r})=>e(k,{onClick:()=>(e=>{D(!1),l&&l(e)})(i),selected:i===I,children:["function"==typeof o&&n(T,{children:n(o,{})}),t,!r&&n($,{children:n(x,{text:g("restrictions.channelTooltip"),place:"bottom",children:n(z,{children:n(p,{fill:"#ff0000"})})})})]},i)))]})]})}));export{E as ChannelSwitcher};
//# sourceMappingURL=ChannelSwitcher.js.map
